/* eslint no-param-reassign: ["error", { "props": false }] */
import Cookie from 'js-cookie';
import whenDomReady from 'when-dom-ready';
function updateScriptsState() {
    const categories = ['analytics', 'advertisement', 'performance', 'functional', 'necessary'];
    categories.forEach(cat => {
        const cookieConsent = Cookie.get('cookieyes-consent');
        if (cookieConsent && cookieConsent.length > 0) {
            const cookiesState = cookieConsent.split(',');
            const cookieCat = cookiesState.find((c) => c.includes(cat));
            if (cookieCat && cookieCat.length > 0 && cookieCat.split(':')[1] === 'yes') {
                Array.from(document.querySelectorAll(`script[type="text/plain"][data-cookieyes-category="${cat}"]`)).forEach((script) => {
                    script.type = 'text/javascript';
                });
            }
        }
    });
}
function initialise() {
    updateScriptsState();
    document.addEventListener('cookieyes_consent_update', updateScriptsState);
}
whenDomReady().then(initialise);
